export enum Role {
  USER = -1,
  IS_ADMIN,
  SUPER_ADMIN = 2
}
